import isEmpty from 'lodash/isEmpty';

export function localStorageAvailable() {
  const storage = window.localStorage;
  try {
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}
export function getGlobalData() {
  if (!localStorageAvailable()) {
    return {};
  }

  try {
    // don't ask why we have to have the key here, if we use the const above, we always get null 🤷‍
    // by using the string, we actually get the data
    const lsData = localStorage.getItem('GLOBAL_DATA');
    return JSON.parse(lsData || '{}');
  } catch (ex) {
    return {};
  }
}
export const loadFromLocal = () => {
  const globalData = getGlobalData();

  if (isEmpty(globalData)) {
    return null;
  }

  if (!globalData.user) {
    return null;
  }

  return globalData.user.selected_language;
};
export const findByNavigator = () => {
  // Possible values https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/languages)
  if (!navigator) return null;

  // Chrome + Firefox
  if (navigator.languages) return navigator.languages[0];

  if (navigator.language) return navigator.language;

  return null;
};
